import React, { Component } from "react";
import items from "./data";

const FlowerContext = React.createContext();

function formatData(items) {
  return items.map(item => {
    let id = item.sys.id;
    let images =
      item.fields.images &&
      item.fields.images.map(image => image.fields.file.url);
    return { ...item.fields, images, id };
  });
}

const flowers = formatData(items);
const featuredFlowers = flowers.filter(flower => flower.featured === true);
const maxPrice = Math.max(...flowers.map(item => item.price), 0);
const maxSize = Math.max(...flowers.map(item => item.size), 0);

class FlowerProvider extends Component {
  state = {
    flowers,
    sortedFlowers: flowers,
    featuredFlowers,
    loading: false,
    type: "all",
    price: maxPrice,
    minPrice: 0,
    maxPrice,
    maxSize,
    available: false
  };

  getFlower = slug => {
    let tempFlowers = [...this.state.flowers];
    const flower = tempFlowers.find(flower => flower.slug === slug);
    return flower;
  };

  handleChange = event => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = event.target.name;
    this.setState(
      {
        [name]: value
      },
      this.filterFlowers
    );
  };

  filterFlowers = () => {
    let { flowers, type, price, available } = this.state;

    let tempFlowers = [...flowers];

    price = parseInt(price);

    if (type !== "все") {
      tempFlowers = tempFlowers.filter(flower => flower.type === type);
    }

    tempFlowers = tempFlowers.filter(flower => flower.price <= price);

    if (available) {
      tempFlowers.filter(flower => flower.available === true);
    }

    this.setState({
      sortedFlowers: tempFlowers
    });
  };

  render() {
    return (
      <FlowerContext.Provider
        value={{
          ...this.state,
          getFlower: this.getFlower,
          handleChange: this.handleChange
        }}
      >
        {this.props.children}
      </FlowerContext.Provider>
    );
  }
}

const FlowerConsumer = FlowerContext.Consumer;

export function withFlowerConsumer(Component) {
  return function ConsumerWrapper(props) {
    return (
      <FlowerConsumer>
        {value => <Component {...props} context={value} />}
      </FlowerConsumer>
    );
  };
}

export { FlowerProvider, FlowerConsumer, FlowerContext };
